import { azureFetch } from "./azureFetch";

export const fetchRatings = async() => {
    try {
        const response = await azureFetch("rating-statistics", {});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchSensorCmlCounts = async() => {
    try {
        const response = await azureFetch("sensor-cml-count", {});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchAssetMonthlyStatistics = async(filter) => {
    try {
        const response = await azureFetch("monthly-statistics", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchAssetSitePageStatistics = async(filter) => {
    try {
        const response = await azureFetch("site-page-statistics", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchSites = async() => {
    try {
        const response = await azureFetch("sites", {});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchPageData = async(filter) => {
    try {
        const response = await azureFetch("page-data", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchUserData = async(filter) => {
    try {
        const response = await azureFetch("user-data", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchAssetData = async(filter) => {
    try {
        const response = await azureFetch("asset-data", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchDataForPage = async(filter) => {
    try {
        const response = await azureFetch("data-for-page", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};

export const fetchDataForUser = async(filter) => {
    try {
        const response = await azureFetch("data-for-user", {where_clause: filter});
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor rating data:", error);
        throw error;
    }
};